export const DOCUMENTS_PATHS = {
	DOCUMENT: '/dokument/:alias',
	ABOUT_US: '/dokument/o-nas',
	REGULATIONS: '/dokument/regulamin',
	PRIVACY_POLICY: '/dokument/polityka-prywatnosci',
	COOKIES_POLICY: '/dokument/polityka-cookies',
	FAQ: '/dokument/faq'
};
